import React, { useState } from "react";
import { useDrop, useDrag } from "react-dnd";
import { Card, CardContent, Typography, Grid } from "@material-ui/core";
import update from "immutability-helper";
import { CirclePicker } from "react-color";
import axiosClient from "../axiosClient";
import { useStateContext } from "../context/ContextProvider";
import Avatar from "@mui/material/Avatar";

const ItemTypes = {
  CARD: "card",
};

function GridDraggableCard({
  id,
  text,
  index,
  photo,
  moveCard,
  color,
  cards,
  setCards,
  products,
}) {
  const [showColorSelect, setShowColorSelect] = useState(false);

  const [, ref] = useDrag({
    type: ItemTypes.CARD,
    item: { id, index },
  });

  const [, drop] = useDrop({
    accept: ItemTypes.CARD,
    hover(item) {
      if (item.index !== index) {
        moveCard(item.index, index);
        item.index = index;
      }
    },
  });

  const { store } = useStateContext();

  const correctStoreName = JSON.parse(store).name.replace(/[^a-zA-Z]/g, "");
  const databaseStoreName = `DB301_${JSON.parse(store).id}_${correctStoreName}`;

  const defaultColors = CirclePicker.defaultProps.colors;
  console.log(defaultColors)
  const removeTheBlues = defaultColors.filter((color) => color!== "#3f51b5" && color!== "#2196f3" && color!== "#03a9f4" && color!== "#607d8b" && color!=="#00bcd4")
  const colors = ["#FFFFFF", ...removeTheBlues];
  

  return (
    <Grid
      item
      xs={3}
      ref={(node) => ref(drop(node))}
      style={{ cursor: "move" }}
      onClick={() => {
        setShowColorSelect(!showColorSelect);
      }}
    >
      <Card
        style={{
          backgroundColor: showColorSelect
            ? "lightgrey"
            : JSON.parse(color)?.hex,
        }}
      >
        <CardContent>
          {/* {!showColorSelect && <Avatar alt={text} src={`http://localhost/${databaseStoreName}/${photo}${id}.jpg`} />}
          {!showColorSelect && <Typography variant="body1">{text}</Typography>} */}
          {!showColorSelect && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <Avatar
                sx={{ width: 60, height: 60 }}
                alt={text}
                src={`${process.env.REACT_APP_PHOTO_URL}/${databaseStoreName}/${photo}${id}.jpg`}
              /> 
              <Typography variant="body1">{text}</Typography>
            </div>
          )}
          {showColorSelect && (
            <CirclePicker
              circleSize={10}
              colors={colors}
              onChange={(color) => {
                const correctStoreName = JSON.parse(store).name.replace(
                  /[^a-zA-Z]/g,
                  ""
                );
                const databaseStoreName = `DB301_${
                  JSON.parse(store).id
                }_${correctStoreName}`;

                const payload = {
                  params: {
                    shopName: databaseStoreName,
                    id: id,
                    color: JSON.stringify(color),
                  },
                };

                axiosClient
                  .patch("products/changeColor", payload)
                  .then(() => {
                    const updatedCards = products.map((item) =>
                      item.id === id
                        ? { ...item, color: JSON.stringify(color) }
                        : item
                    );
                    console.log(updatedCards)
                    setCards(updatedCards);
                  })
                  .catch((err) => console.log(err));
              }}
            />
          )}
        </CardContent>
      </Card>
    </Grid>
  );
}

function GridDraggableCards({ cards, setCards, products }) {
  const { store } = useStateContext();

  const correctStoreName = JSON.parse(store).name.replace(/[^a-zA-Z]/g, "");
  const databaseStoreName = `DB301_${JSON.parse(store).id}_${correctStoreName}`;

  const moveCard = (dragIndex, hoverIndex) => {
    const draggedCard = cards[dragIndex];
    const changedWithCard = cards[hoverIndex];

    const payload = {
      params: {
        shopName: databaseStoreName,
        orderProductOne: draggedCard.order,
        orderProductTwo: changedWithCard.order,
        idProductOne: changedWithCard.id,
        idProductTwo: draggedCard.id,
      },
    };

    axiosClient
      .patch("products/changeOrder", payload)
      .catch((err) => console.log(err));

    setCards(
      update(cards, {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, draggedCard],
        ],
      })
    );
  };

  return (
    <Grid container spacing={2}>
      {cards.map((card, index) => (
        <GridDraggableCard
          key={card.id}
          index={index}
          photo={card.photo}
          id={card.id}
          text={card.name}
          color={card.color}
          cards={cards}
          setCards={setCards}
          moveCard={moveCard}
          products={products}
        />
      ))}
      {cards.length === 0 && (
        <Typography variant="body1">No products on this category</Typography>
      )}
    </Grid>
  );
}

export default GridDraggableCards;
